import { useQuery } from '@tanstack/react-query';
import { getBalanceReport } from 'config/requests/balanceReport';
import { BalanceReportFilterValues } from 'pages/Finance/BalanceReport/BalanceReportList';
import { BalanceReport } from 'types/embedded/balanceReport';
import { cleanEmpty } from 'utils/cleanEmpty';

export function useBalanceReportList(filters: BalanceReportFilterValues): {
  balanceList: BalanceReport | undefined;
  isLoading: boolean;
} {
  const { data: balanceList, isLoading } = useQuery({
    queryKey: ['balance_list', filters],
    queryFn: () => getBalanceReport(filters),
    enabled: !!Object.values(cleanEmpty(filters)).length,
  });

  return { balanceList, isLoading };
}
